/**
 * This module offers helper functions for dealing with Lav types.
 *
 * A Lav can be used in a WUI input component to render a list of options where the label differs from the value.
 * Lav is slang for 'LabelValue'.
 *
 * A label can only be a string or a number, eg. it must mean something to a user. A value can be anything.
 */
function toValue(o) {
    if (o && typeof o === 'object' && 'value' in o) {
        return o.value;
    }
    return o;
}
function toLabel(o) {
    if (o && typeof o === 'object' && 'label' in o && typeof o.label === 'string') {
        return o.label;
    }
    return String(o);
}
function toLav(i) {
    if (i && typeof i === 'object' && 'label' in i && 'value' in i) {
        return i;
    }
    return {
        ...(i && typeof i === 'object' ? i : {}),
        label: toLabel(i),
        value: toValue(i),
    };
}

export { toValue as a, toLav as b, toLabel as t };

//# sourceMappingURL=index5.js.map